import React from "react";
import { trackEvent } from "@leafly-com/web-utils";
import sortBy from "lodash/sortBy";
import Link from "next/link";

import { ReportedOptions } from "custom-types/StrainList";
import { StrainTag } from "custom-types/StrainTags";
import useDomainCountryCode from "hooks/useDomainCountryCode";

import TrackImpression from "components/TrackImpression";

type Props = {
  reportedOptions: ReportedOptions;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  [x: string]: any;
};

const ExploreOtherCategories = ({ reportedOptions, ...others }: Props) => {
  reportedOptions.conditions = sortBy(reportedOptions.conditions, [
    "displayName",
  ]);

  const countryCode = useDomainCountryCode();

  return (
    <TrackImpression category="Playlist" label="Other Categories" {...others}>
      <h2 className="text-md mb-md">All strains</h2>
      <div className="text-sm">
        {reportedOptions["categories"] &&
          renderCategory("Strain types", "category", [
            ...reportedOptions["categories"],
            {
              displayName: "view all strains",
              slug: "/strains",
            },
          ])}
        {reportedOptions["effects"] &&
          renderCategory(
            "Strains by feeling*",
            "effect",
            reportedOptions["effects"],
          )}
        {reportedOptions["conditions"] &&
          renderCategory(
            "Strains that may help with*",
            "condition",
            reportedOptions["conditions"],
          )}
        {reportedOptions["flavors"] &&
          renderCategory(
            countryCode === "CA"
              ? "Strains by flavour and aroma*"
              : "Strains by flavor and aroma*",
            "flavor",
            reportedOptions["flavors"],
          )}
        {reportedOptions["terpenes"] &&
          renderCategory(
            "Strains by terpene",
            "terpene",
            reportedOptions["terpenes"],
          )}
      </div>
    </TrackImpression>
  );
};

const renderCategory = (
  title: string,
  category: string,
  options: StrainTag[],
) => {
  return (
    <div key={category} className="mb-xl">
      <h3 className="heading--xs mb-sm uppercase">{title}</h3>
      <div className="columns-2 md:columns-4 hyphens-auto text-green">
        {options.map((tag) => (
          <Link
            prefetch={false}
            key={tag.slug}
            href={
              tag.displayName === "view all strains"
                ? `${tag.slug}`
                : `/strains/lists/${encodeURIComponent(
                    category,
                  )}/${encodeURIComponent(tag.slug)}`
            }
            className="block underline mb-lg capitalize"
            onClick={() => {
              trackEvent("Hub", "Click", `${tag.displayName}`);
            }}
          >
            {tag.displayName}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ExploreOtherCategories;
